import dayjs                   from 'dayjs';
import { Dayjs }               from 'dayjs';
import React                   from 'react';
import { Input }               from 'antd';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';

interface CustomDatePickerProps {
  disabled?: boolean;
  id?: string;
  onChange?: (date: Dayjs) => void;
  value?: any;
}

export default class CustomDatePicker extends React.Component<CustomDatePickerProps> {
  public state = {
    date: '',
    hour: '',
  };

  public componentDidMount() {
    this.setDate();
  }

  public componentDidUpdate(prevProps: CustomDatePickerProps) {
    if (prevProps.value !== this.props.value) {
      this.setDate();
    }
  }

  public render() {
    const { disabled, id } = this.props;

    return (
      <>
        <div className="custom-date-setter">
          <div style={{ width: '50%' }}>
            <Input
              data-testid={id && `${id}-date`}
              disabled={disabled}
              maxLength={10}
              onBlur={this.handleOnBlur}
              onChange={event => this.handleChange(event, 'date')}
              placeholder={dayjs().format('DD/MM/YYYY')}
              value={this.state.date}
            />
          </div>
          <div style={{ textAlign: 'center', width: '10%' }}>
            <FormattedMessageWrapper id="à" />
          </div>
          <div style={{ width: '40%' }}>
            <Input
              data-testid={id && `${id}-time`}
              disabled={disabled}
              maxLength={5}
              onBlur={this.handleOnBlur}
              onChange={event => this.handleChange(event, 'hour')}
              placeholder={dayjs().format('HH[h]mm')}
              value={this.state.hour}
            />
          </div>
        </div>
      </>
    );
  }

  private handleChange = (event: any, fieldname: string) => {
    this.setState({
      [fieldname]: event.target.value,
    });
  };

  private handleOnBlur = () => {
    const { onChange } = this.props;

    if (!this.state.date || !this.state.hour) {
      return;
    }

    const date = `${this.state.date} ${this.state.hour}`;

    const dateObject = dayjs(date, 'DD/MM/YYYY H[h]m');

    if (dateObject.isValid()) {
      if (onChange) onChange(dateObject);
    }
  };

  private setDate = () => {
    const { value } = this.props;

    if (!value || !value.isValid()) {
      return;
    }

    this.setState({
      date: value.format('DD/MM/YYYY'),
      hour: value.format('HH[h]mm'),
    });
  };
}
